import * as fromDatatype from '../datatype-library';

export interface bl_fi_deposit_requisition_hdr_entity_attachment_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    req_hdr_entity_guid: fromDatatype.GuidDataFieldInterface;
    file_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    file_name: fromDatatype.VarcharDatatypeInterface;
    import_format: fromDatatype.VarcharDatatypeInterface;
    file_details: fromDatatype.VarcharDatatypeInterface;
    upload_date: fromDatatype.TimestampTzDatatypeInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_deposit_requisition_hdr_entity_attachment_RowClass implements bl_fi_deposit_requisition_hdr_entity_attachment_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    req_hdr_entity_guid: fromDatatype.GuidDataFieldInterface;
    file_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    file_name: fromDatatype.VarcharDatatypeInterface;
    import_format: fromDatatype.VarcharDatatypeInterface;
    file_details: fromDatatype.VarcharDatatypeInterface;
    upload_date: fromDatatype.TimestampTzDatatypeInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
